import { render, staticRenderFns } from "./change-profile-picture-dialog.vue?vue&type=template&id=5157b495&scoped=true"
import script from "./change-profile-picture-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./change-profile-picture-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./change-profile-picture-dialog.vue?vue&type=style&index=0&id=5157b495&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5157b495",
  null
  
)

export default component.exports